
import React from 'react';
import '../../../AdminUsers/AdminTableUsersMain/TableUsers/TableUsers.scss';

export default class TableUsers extends React.Component {
   
   renderTable() {
    let  data =  this.props.adminUsersState;
    return (
        data.map(item => {
            console.log(item);
            return(
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.username}</td>
                    <td>{item.user_nickname}</td>
                    <td className={item.role_title === 'admin' ? 'admin-style' : ''}>{item.role_title}</td>
                    <td>{item.subscription_kind}</td>
                    <td>{item.is_activated ? 'true' : 'false'}</td>
                    <td>{item.publisher}</td>
                    <td>{item.usercountry}</td>
                    <td>{item.useremail}</td>
                    
                    <td>{item.occupation_kind}</td>
                    
                </tr>
                )
            })
        )    
   }
   
    render() {

      //  const data = this.props.data;

        return(
            <div className="TableUsers">
                <table>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Username</th>
                            <th>Nickname</th>
                            <th>Роль(role)</th>
                            <th>Подписка(subscription)</th>
                            <th>Активация(activation)</th>
                            

                            <th>Издатель(publisher)</th>
                            <th>Cтрана(country)</th>
                            <th>Почта(mail)</th>
                            
                            <th>Профессия(occupation)</th>
                            
                            
                            

                        </tr>
                        
                    </thead>
                    <tbody>
                    {this.renderTable()}
                    
                    
                    </tbody>
                
                    
                    

                </table>
                
            </div>
        )
    }
}